import { StringKey } from '../../lang/index';

export const folderTranslation: Record<string, StringKey> = {
  Buybacks: 'BUYBACKS',
  'Class Conversions': 'CLASS_CONVERSIONS',
  'Company Documents': 'COMPANY_DOCUMENTS',
  Dividends: 'DIVIDENDS',
  'Fundraising Rounds': 'FUNDRAISING_ROUNDS',
  Grants: 'GRANTS',
  Plans: 'PLANS',
  Pools: 'POOLS',
  SAFEs: 'SAFES',
  Secondaries: 'SECONDAIRES',
  'Share Classes': 'SHARE_CLASSES',
  'Share Issuances': 'SHARE_ISSUANCES',
  Stakeholders: 'STAKEHOLDERS',
  'Valuation events': 'VALUATION_EVENTS',
  Documents: 'DOCUMENTS',
};
